import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupsForSelection, StateStatus } from '@guryou/redux';
import { resetState } from '../actions';
import { GROUPS_CREATE, GROUPS_UPDATE, PROVIDER_DELETE_GROUP, SERVICE_GROUPS_GET_MANY_FOR_SELECTION } from '../new/group';
const useGroupsForSelection = _ref => {
  let {
    type,
    groupId
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.groups.allForSelection);
  const groupsCreate = useSelector(state => state.groups.create);
  const groupsUpdate = useSelector(state => state.groups.update);
  const groupsDelete = useSelector(state => state.groups.delete);
  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && (request === null || request === void 0 ? void 0 : request.type) !== type) {
      dispatch(getGroupsForSelection(type));
      return;
    }
    if (groupsCreate.status === StateStatus.LOADED) {
      dispatch(resetState(GROUPS_CREATE));
      dispatch(resetState(SERVICE_GROUPS_GET_MANY_FOR_SELECTION));
    }
    if (groupsUpdate.status === StateStatus.LOADED) {
      dispatch(resetState(GROUPS_UPDATE));
      dispatch(resetState(SERVICE_GROUPS_GET_MANY_FOR_SELECTION));
    }
    if (groupsDelete.status === StateStatus.LOADED) {
      dispatch(resetState(PROVIDER_DELETE_GROUP));
      dispatch(resetState(SERVICE_GROUPS_GET_MANY_FOR_SELECTION));
    }
  }, [data, dispatch, groupsCreate.status, groupsDelete.status, groupsUpdate.status, request, status, type]);
  if (groupId) {
    return {
      group: (data || []).find(x => x.id === groupId),
      status,
      version,
      entity
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useGroupsForSelection;